export class PasswordService {
    static readonly MIN_LENGTH = 6
    static readonly PATTERN = '(?=.*[A-Za-z])(?=.*\\d).+'
    static readonly REGEX = new RegExp(`^${PasswordService.PATTERN}$`)

    static isValid(password: string): boolean {
        return password.length >= PasswordService.MIN_LENGTH && PasswordService.REGEX.test(password)
    }

    static getValidationMessage(): string {
        return `Passwort muss mindestens ${PasswordService.MIN_LENGTH} Zeichen lang sein und mindestens einen Buchstaben und eine Zahl enthalten.`
    }

    static getHintText(): string {
        return `Mindestens ${PasswordService.MIN_LENGTH} Zeichen (Buchstaben, Zahlen und Sonderzeichen).`
    }
}
